import React, { useState } from "react";
import { toast } from "sonner";
import { api, can, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { lbl } from "@/constants/labels";
import { Pencil, Save, X, Link2 } from "lucide-react";

const inp = "w-full rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 text-sm focus:border-vino-500 focus:outline-none";
const SOLO_LECTURA = ["tipo_documento", "numero_documento"];

export function DatosEmpleadoPanel({ expedienteId, datos, onSaved }) {
  const { user } = useAuth();
  const [edit, setEdit] = useState(false);
  const [form, setForm] = useState(datos || {});
  const [saving, setSaving] = useState(false);
  const faltan = Object.keys(datos || {}).filter((k) => !datos[k]);
  const guardar = async () => {
    setSaving(true);
    const cambios = Object.fromEntries(Object.entries(form).filter(([k, v]) => (v || "") !== (datos[k] || "")));
    try {
      await api.patch(`/expedientes/${expedienteId}/datos-personales`, { campos: cambios });
      toast.success("Datos guardados en la hoja de vida del empleado");
      setEdit(false); onSaved();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };
  return (
    <div className="mb-5 rounded-lg border border-slate-200 bg-slate-50/60 p-4" data-testid="datos-empleado-panel">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 text-sm font-medium text-slate-700"><Link2 className="h-4 w-4 text-vino-700" /> Datos del empleado — tomados de su hoja de vida</p>
        {can(user, "editar") && (edit ? (
          <div className="flex gap-2">
            <button onClick={() => { setEdit(false); setForm(datos); }} className="flex items-center gap-1 rounded-lg border border-slate-200 px-2.5 py-1 text-xs" data-testid="datos-empleado-cancelar"><X className="h-3.5 w-3.5" /> Cancelar</button>
            <button onClick={guardar} disabled={saving} className="flex items-center gap-1 rounded-lg bg-vino-700 px-2.5 py-1 text-xs font-semibold text-white disabled:opacity-50" data-testid="datos-empleado-guardar"><Save className="h-3.5 w-3.5" /> Guardar en hoja de vida</button>
          </div>
        ) : <button onClick={() => { setForm(datos); setEdit(true); }} className="flex items-center gap-1 rounded-lg border border-slate-200 bg-white px-2.5 py-1 text-xs" data-testid="datos-empleado-editar"><Pencil className="h-3.5 w-3.5" /> Completar o corregir</button>)}
      </div>
      {faltan.length > 0 && !edit && <p className="mb-3 text-xs text-amber-700" data-testid="datos-empleado-faltan">Faltan {faltan.length} datos: complétalos aquí o pídelos al empleado en su hoja de vida.</p>}
      <dl className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {Object.keys(datos || {}).map((k) => (
          <div key={k}>
            <dt className="text-[11px] text-slate-400">{lbl(k)}</dt>
            {edit && !SOLO_LECTURA.includes(k) ? <input type={k.startsWith("fecha_") ? "date" : "text"} className={inp} value={form[k] || ""} onChange={(e) => setForm((p) => ({ ...p, [k]: e.target.value }))} data-testid={`datos-empleado-input-${k}`} />
              : <dd className={`text-sm ${datos[k] ? "text-slate-700" : "text-amber-600"}`} data-testid={`datos-empleado-${k}`}>{datos[k] || "Falta"}</dd>}
          </div>
        ))}
      </dl>
    </div>
  );
}
